import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks/typedHooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';

const AtlasV2OrganicTrafficV2OrganicKeywordCountSplineChart = () => {
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimeDisplayName = useComparisonTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();

  return (
    <AtlasV2DorisSplineChart
      queryKey="organicTrafficKeywordCountSplineChart"
      title="Keyword Count with Organic Traffic"
      showLastWeekValue
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType="KeywordsWithOrganicTrafficCount"
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`The chart displays the unique number of keywords that generated organic traffic for ${entityPhrase} ${taxonomyText} during the 
                ${mainTimePeriodShortDisplayName} period compared to the ${comparisonTimeDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2OrganicTrafficV2OrganicKeywordCountSplineChart;
